import { render, staticRenderFns } from "./UserRow.vue?vue&type=template&id=36d16e9d&scoped=true"
import script from "./UserRow.vue?vue&type=script&lang=js"
export * from "./UserRow.vue?vue&type=script&lang=js"
import style0 from "./UserRow.vue?vue&type=style&index=0&id=36d16e9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d16e9d",
  null
  
)

export default component.exports